import React, { useEffect, useContext, useState } from "react";
import { ThemeContext } from "./ThemeContext";
import { Button, Input, Alert, Modal } from "antd";
import axios from "axios";

const Edit = ({ match }) => {
  const [dark, setDark] = useContext(ThemeContext);
  const [load, setLoad] = useState(false);
  const [error, setError] = useState(false);

  const [t0, setT1] = useState("");
  const [t1, setT2] = useState("");
  const [image, setImage] = useState("");
  const [visible, setVisible] = useState(false);

  const send = async () => {
    if (t0 && t1) {
      setLoad(true);
      setError(false);
      await fetch("https://api.imgflip.com/caption_image", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: `template_id=${match.params.id}&username=syntax66&password=qpalzmqp&text0=${t0}&text1=${t1}&font=Arial`
      })
        .then(response => {
          response
            .json()
            .then(res => {
              setImage(res.data.url);
              setLoad(false);
              setVisible(true);
            })
            .catch(err => console.log(err));
        })
        .catch(error => {
          console.log(error);
          setLoad(false);
        });
    } else {
      setError(true);
    }
  };
  return (
    <div
      style={{
        paddingTop: 70,
        minHeight: "100vh",
        backgroundColor: dark ? "black" : "white"
      }}>
      <div style={{ marginRight: "auto", marginLeft: "auto", width: "60%" }}>
        <Input
          placeholder="Top Text"
          size="large"
          onChange={value => setT1(value.target.value)}
          style={{ fontWeight: "bold", textAlign: "center", marginTop: 20 }}
        />
        <Input
          placeholder="Bottom Text"
          size="large"
          onChange={value => setT2(value.target.value)}
          style={{ fontWeight: "bold", textAlign: "center", marginTop: 20 }}
        />
        <Button
          loading={load}
          type="primary"
          style={{ marginTop: 20 }}
          onClick={() => send()}>
          Download
        </Button>
        <Modal
          title="Final Version"
          visible={visible}
          onOk={() => setVisible(false)}
          footer={[
            <Button key="back" onClick={() => setVisible(false)}>
              Cancel
            </Button>,
            <a href={image} target="_blank" rel="noopener noreferrer" download>
              <Button key="submit" type="primary" loading={load}>
                Download
              </Button>
            </a>
          ]}
          onCancel={() => setVisible(false)}>
          <img src={image} style={{ aspectRatio: 1, width: 250 }} />
        </Modal>
        {error ? (
          <Alert
            message="Enter Text"
            type="error"
            showIcon
            style={{ marginTop: 20 }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Edit;
